module.exports = __webpack_public_path__ + "static/img/live-score-txt.9b0db09.png";